import { Crop } from "react-image-crop";

export const defaultCropOptions: Crop = {
  unit: "px",
  width: 350,
  height: 350,
  aspect: 1 / 1,
  x: 0,
  y: 0,
};

function getCroppedImage(image: HTMLImageElement, crop: Crop, fileName: string): Promise<File> {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  if (crop.width && crop.height) {
    canvas.width = crop.width;
    canvas.height = crop.height;
  }

  const ctx = canvas.getContext("2d");

  if (crop.width && crop.height) {
    ctx?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob: any) => {
        if (blob) {
          blob.name = fileName;
          resolve(blob);
        } else {
          reject(new Error("Canvas is empty"));
        }
      },
      "image/jpeg",
      1,
    );
  });
}

export default getCroppedImage;
